"use client";
import s, { useRef as h, useEffect as i } from "react";
import { Chart as l, BarController as x, LineController as y, CategoryScale as C, LinearScale as g, BarElement as E, PointElement as v, LineElement as L, Title as S, Tooltip as b, Legend as k, Filler as I } from "./index.es161.js";
import { Chart as _ } from "./index.es162.js";
import w from "./index.es163.js";
import B from "./index.es164.js";
import R from "./index.es165.js";
import T from "./index.es141.js";
import j from "./index.es166.js";
const z = T.div`
  position: relative;
  min-height: 500px;
`;
l.register(
  x,
  y,
  w,
  R,
  C,
  g,
  E,
  v,
  L,
  S,
  b,
  k,
  I,
  B,
  j
);
l.defaults.font.size = 16;
const G = ({
  data: t,
  options: m,
  type: c,
  highlightLabel: a,
  keyContext: f,
  onChartChange: n
}) => {
  const e = h(void 0);
  i(() => (e.current && n && n(e.current), () => {
    e.current && e.current.destroy();
  }), []);
  const d = (p) => {
    if (t.datasets) {
      const r = t.datasets.findIndex(
        (o) => o.label === p
      );
      if (r >= 0)
        return t.datasets[r].data.map((o, u) => ({
          datasetIndex: r,
          index: u
        }));
    }
    return [];
  };
  return i(() => {
    e.current && e.current.setActiveElements(
      d(a || "")
    );
  }, [a]), /* @__PURE__ */ s.createElement(z, { className: "chartjs-wrapper", "aria-hidden": "true" }, /* @__PURE__ */ s.createElement(
    _,
    {
      ref: e,
      key: f,
      data: t,
      options: m,
      type: c
    }
  ));
};
export {
  G as default
};
//# sourceMappingURL=index.es91.js.map
